export const ADD_NEW_CUSTOMER = 'ADD_NEW_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const LOAD_EDITABLE_CUSTOMER = 'LOAD_EDITABLE_CUSTOMER';
export const SET_EMPTY_EDITABLE_CUSTOMER = 'SET_EMPTY_EDITABLE_CUSTOMER';
export const LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
export const SET_CUSTOMER_PAGINATION = 'SET_CUSTOMER_PAGINATION';
export const SET_CUSTOMER_FILTER = 'SET_CUSTOMER_FILTER';
export const SET_CUSTOMER_SORT = 'SET_CUSTOMER_SORT';
export const RESET_CUSTOMER_FILTERS = 'RESET_CUSTOMER_FILTERS';
export const LOAD_CONTACTS = 'LOAD_CONTACTS';
export const SET_CONTACT_PAGINATION = 'SET_CONTACT_PAGINATION';
export const SET_CONTACT_SORT = 'SET_CONTACT_SORT';
export const SET_CONTACT_FILTER = 'SET_CONTACT_FILTER';
export const ADD_NEW_CONTACT = 'ADD_NEW_CONTACT';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const SET_EMPTY_EDITABLE_CONTACT = 'SET_EMPTY_EDITABLE_CONTACT';
export const ADD_NEW_ADDRESS = 'ADD_NEW_ADDRESS';
export const LOAD_SHIPPING_ADDRESSES = 'LOAD_SHIPPING_ADDRESSES';
export const SET_SHIPPING_ADDRESS_PAGINATION = 'SET_SHIPPING_ADDRESS_PAGINATION';
export const SET_SHIPPING_ADDRESS_SORT = 'SET_SHIPPING_ADDRESS_SORT';
export const LOAD_BILLING_ADDRESSES = 'LOAD_BILLING_ADDRESSES';
export const SET_BILLING_ADDRESS_PAGINATION = 'SET_BILLING_ADDRESS_PAGINATION';
export const SET_BILLING_ADDRESS_SORT = 'SET_BILLING_ADDRESS_SORT';
export const SET_SHIPPING_ADDRESS_FILTER = 'SET_SHIPPING_ADDRESS_FILTER';
export const RESET_SHIPPING_ADDRESS_FILTERS = 'RESET_SHIPPING_ADDRESS_FILTERS';
export const SET_BILLING_ADDRESS_FILTER = 'SET_BILLING_ADDRESS_FILTER';
export const RESET_BILLING_ADDRESS_FILTERS = 'RESET_BILLING_ADDRESS_FILTERS';
export const SET_DISABLE_SHIPPING_ADDRESS = 'SET_DISABLE_SHIPPING_ADDRESS';
export const SET_DISABLE_BILLING_ADDRESS = 'SET_DISABLE_BILLING_ADDRESS';
export const EDIT_ADDRESS = 'EDIT_ADDRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const LOAD_CUSTOMER_ORDERS = 'LOAD_CUSTOMER_ORDERS';
export const SET_CUSTOMER_ORDERS_PAGINATION = 'SET_CUSTOMER_ORDERS_PAGINATION';
export const SET_CUSTOMER_ORDERS_SORT = 'SET_CUSTOMER_ORDERS_SORT';
export const SET_CUSTOMER_ORDERS_FILTER = 'SET_CUSTOMER_ORDERS_FILTER';
export const RESET_CUSTOMER_ORDERS_FILTERS = 'RESET_CUSTOMER_ORDERS_FILTERS';
export const LOAD_CUSTOMER_QUOTES = 'LOAD_CUSTOMER_QUOTES';
export const SET_CUSTOMER_QUOTES_FILTER = 'SET_CUSTOMER_QUOTES_FILTER';
export const SET_CUSTOMER_QUOTES_PAGINATION = 'SET_CUSTOMER_QUOTES_PAGINATION';
export const SET_CUSTOMER_QUOTES_SORT = 'SET_CUSTOMER_QUOTES_SORT';
export const RESET_CUSTOMER_QUOTES_FILTERS = 'RESET_CUSTOMER_QUOTES_FILTERS';
export const LOAD_CUSTOMER_QUOTES_CONTACT = 'LOAD_CUSTOMER_QUOTES_CONTACT';
export const LOAD_CUSTOMER_QUOTES_SENDER = 'LOAD_CUSTOMER_QUOTES_SENDER';
export const SET_CUSTOMER_TAB = 'SET_CUSTOMER_TAB';
export const ADD_NEW_INVOICE = 'ADD_NEW_INVOICE';
export const LOAD_CUSTOMER_INVOICES = 'LOAD_CUSTOMER_INVOICES';
export const SET_CUSTOMER_INVOICES_PAGINATION = 'SET_CUSTOMER_INVOICES_PAGINATION';
export const SET_CUSTOMER_INVOICES_SORT = 'SET_CUSTOMER_INVOICES_SORT';
export const SET_CUSTOMER_INVOICES_FILTER = 'SET_CUSTOMER_INVOICES_FILTER';
export const RESET_CUSTOMER_INVOICES_FILTERS = 'RESET_CUSTOMER_INVOICES_FILTERS';
export const LOAD_CUSTOMER_PROFORMA = 'LOAD_CUSTOMER_PROFORMA';
export const SET_CUSTOMER_PROFORMA_PAGINATION = 'SET_CUSTOMER_PROFORMA_PAGINATION';
export const SET_CHECKED_CUSTOMER_PROFORMA = 'SET_CHECKED_CUSTOMER_PROFORMA';
export const SELECT_CUSTOMER_PROFORMA = 'SELECT_CUSTOMER_PROFORMA';
export const SET_CUSTOMER_PROFORMA_SORT = 'SET_CUSTOMER_PROFORMA_SORT';
export const SET_CUSTOMER_PROFORMA_FILTER = 'SET_CUSTOMER_PROFORMA_FILTER';
export const RESET_CUSTOMER_PROFORMA_FILTERS = 'RESET_CUSTOMER_PROFORMA_FILTERS';
export const LOAD_BILLING_ADDRESS_FOR_FINANCE = 'LOAD_BILLING_ADDRESS_FOR_FINANCE';
export const SET_EMPTY_BILLING_ADDRESS_FOR_FINANCE = 'SET_EMPTY_BILLING_ADDRESS_FOR_FINANCE';
export const LOAD_INVOICE_DETAILS = 'LOAD_INVOICE_DETAILS';
export const LOAD_CUSTOMER_TURNOVER = 'LOAD_CUSTOMER_TURNOVER';
export const SET_EMPTY_CUSTOMER_TURNOVER = 'SET_EMPTY_CUSTOMER_TURNOVER';
export const DOWNLOAD_ALL_INVOICES = 'DOWNLOAD_ALL_INVOICES';
export const CREATE_GROUPED_INVOICE = 'CREATE_GROUPED_INVOICE';
export const GENERATE_CREDIT_NOTE_INVOICE = 'GENERATE_CREDIT_NOTE_INVOICE';
export const REGENERATE_PROFORMA = 'REGENERATE_PROFORMA';
